// extracted by mini-css-extract-plugin
export default {"Logo":"SwaggerLogo_Logo__eCrRa"};